import React from 'react';
import styles from 'pages/AccountSettings.module.css';
import { Link } from 'react-router';
import globalStyles from 'Global.module.css';

const AccountSettings: React.FC = () => {
  return (
    <div className={styles.accountSettings}>
      <h1>Account Settings</h1>
          <div className={globalStyles.shadowBox}>
              <Link to="/edit-profile">Edit Profile</Link>
          </div>
    </div>
  );
};

export default AccountSettings;
